// A contract's PDF, as the API answers it ({ filename, pdf: base64 }), made the
// file's bytes (for the PDF viewer), a file the browser can show (an object
// url) or save.
export function pdfBytes(answer) {
  if (!answer?.pdf) return null
  return Uint8Array.from(atob(answer.pdf), (c) => c.charCodeAt(0))
}

export function pdfUrl(answer) {
  const bytes = pdfBytes(answer)
  if (!bytes) return null
  return URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }))
}

export function downloadPdf(answer) {
  const url = pdfUrl(answer)
  if (!url) return false
  const a = document.createElement("a")
  a.href = url
  a.download = answer.filename || "contract.pdf"
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 10000)
  return true
}

// Any file the API answers as { filename, contentType, file: base64 } (the
// accountant's invoice export: a CSV or a ZIP), saved by the browser.
export function downloadFile(answer) {
  if (!answer?.file) return false
  const bytes = Uint8Array.from(atob(answer.file), (c) => c.charCodeAt(0))
  const url = URL.createObjectURL(new Blob([bytes], { type: answer.contentType || "application/octet-stream" }))
  const a = document.createElement("a")
  a.href = url
  a.download = answer.filename || "download"
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 10000)
  return true
}
